import {Component, Input, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    standalone: false
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @Input() taskId;
  @Input() finished = false;
  progress = 0;
  interval;

  @Output() completed = new EventEmitter<boolean>();
  @Output() error = new EventEmitter<any>();
  @Output() context = new EventEmitter<any>();

  constructor(private http: HttpClient) {}

  getProgress() {
    this.http.get<any>(`/rest-api/v1/celery/tasks/${this.taskId}/progress`).subscribe(res => {
      if (res.error) {
        this.error.emit(res.error);
        clearInterval(this.interval);
        return;
      }
      if (res.progress) {
        this.progress = Math.round(res.progress * 100);
        if (this.progress === 100) {
          this.completed.emit(true);
          this.context.emit(res);
          clearInterval(this.interval);
        }
      }
    });
  }

  ngOnInit(): void {
    if (!this.finished) {
      this.interval = setInterval(() => {
        this.getProgress();
      }, 1000);
    } else {
      this.progress = 100;
    }
  }

  ngOnDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
